import {useDialog} from "../../../hooks/useDialog";
import React, {useEffect, useMemo, useState} from "react";
import {DynamicFields, fieldTemplateToColumn} from "../../../utils/dynamicFields";
import {FillerSection} from "../../FillerSection/FillerSection";
import Autocomplete from "@material-ui/lab/Autocomplete";
import TextField from "@material-ui/core/TextField";
import {FakeFieldGrid} from "../../FakeFieldGrid/FakeFieldGrid";
import {AddFieldTemplateDialog} from "../AddFieldTemplateDialog";
import {getNumericId} from "../../../utils/uniqueIds";
import { DataGrid } from "@material-ui/data-grid";
import { Button, Grid, Typography } from "@material-ui/core";
import { AddButton } from "../../AddButton/AddButton";
import {makeStyles} from "@material-ui/core";
import { FakeAddCheckListField } from "../../FakeAddCheckListField/FakeAddCheckListField";
import NormativeDocumentsTreePage from "../../../pages/NormativeDocumentsTreePage/NormativeDocumentsTreePage";
import { DeleteButton } from "../../DeleteButton/DeleteButton";
import { SaveButton } from "../../SaveButton/SaveButton";
import AddDocumentCheckList from "../../AddDocumentCheckList/AddDocumentCheckList";
import { useDispatch, useSelector } from "react-redux";
import { checkListSelector, getCheckListInfo, setNormativeArticles, setNormativeChapters, setNormativeDocumentTree, startLoading, stopLoading } from "../../../redux/reducers/normative-documents-reducer";
import NormativeDocumentEditPage from "../../../pages/NormativeDocumentEditPage/NormativeDocumentEditPage";
import TreeCheckListFiller from "./TreeCheckListFiller";


const getPropsColumn = (pole) => {
    let propsColumns = []
    if (pole) {
        pole.map((el) => {
            let colomn = 
                 {
                     field: el.label, 
                     headerName: el.label, 
                     width: 140,
                     editable: true,
                 }
             propsColumns.push(colomn)
         })
    }
    const columns = [...[
         { field: 'id', 
           headerName: 'Название', 
           width: 140,
           editable: false,
         },
         
       ], ...propsColumns];
    
    return columns
}

const getPropsRow = (pole) => {
    let propsRows = {}
    if (pole) {
        pole.map((el) => {
            let row = 
            {
                [el.label]: el.type,    
            }
            propsRows = {...propsRows, ...row}
         })
    }
    const rows = [
        { id: 'Тип элемента', ...propsRows},
      ];
    
    return rows
}



const useStyles = makeStyles(() => ({
    addButton: {
        display: 'flex',
        alignItems: 'center',
    },
}))

export const CheckListFiller = ({content, setFieldValue}) => {

    const dispatch = useDispatch()

    const { normativeDocumentTree, normativeChapters, normativeArticles, checkListId} = useSelector(getCheckListInfo)
   
    useEffect(() => {
        if (content?.normativeDocumentTree !== undefined) {
            dispatch(setNormativeDocumentTree(content.normativeDocumentTree))
            dispatch(setNormativeChapters(content.normativeChapters))
            dispatch(setNormativeArticles(content.normativeArticles))
        }
    },[])

    useEffect(() => {
        if (normativeDocumentTree.length !== 0){
            setFieldValue('content', {
                ...content,
                normativeDocumentTree: normativeDocumentTree,
                normativeChapters: normativeChapters,
                normativeArticles: normativeArticles,
                checkListId: checkListId,
            })}
    },[normativeDocumentTree, normativeChapters, normativeArticles, checkListId])

    const style = useStyles()

    const [column, setColumn] = useState(getPropsColumn(content.offenseWindow))
    const [row, setRow] = useState(getPropsRow(content.offenseWindow))

    const {open, handleClose, handleOpen} = useDialog()
    const [selectedFieldTemplateIndex, setSelectedFieldTemplateIndex] = useState(null)

    const offenseWindow = content?.offenseWindow || []
    const tableConfig = content?.tableConfig || {columns: []}

    const handleFieldTemplateDelete = (deletedField, newFields) => {
        setFieldValue('content', {
            ...content,
            offenseWindow: newFields,
            filesVariable: DynamicFields.DRAG_AND_DROP_FILES_UPLOAD === deletedField.type ? '' : content?.filesVariable,
            normativeArticleVariable: deletedField.type === DynamicFields.NORMATIVE_ARTICLES_TABLE
            || deletedField.type === DynamicFields.NORMATIVE_ARTICLE_SELECT ? '' : content?.normativeArticleVariable,
            tableConfig: {
                ...tableConfig,
                columns: tableConfig?.columns?.filter(f => f.field !== deletedField.variable)
            }
        })
    }

    const handleSequenceNumberChange = newFields => {
        setFieldValue('content.offenseWindow', newFields)
    }

    const handleFieldTemplateClick = index => {
        setSelectedFieldTemplateIndex(index)
        handleOpen()
    }

    const handleAddFieldTemplate = fieldTemplate => {
        setFieldValue('content', {
            ...content,
            offenseWindow: [...offenseWindow, {
                ...fieldTemplate,
                id: getNumericId(),
                sequenceNumber: offenseWindow.length + 1
            }],
            filesVariable: fieldTemplate.type === DynamicFields.DRAG_AND_DROP_FILES_UPLOAD ?
                fieldTemplate.variable : content?.filesVariable,
            normativeArticleVariable: fieldTemplate.type === DynamicFields.NORMATIVE_ARTICLES_TABLE ||
            fieldTemplate.type === DynamicFields.NORMATIVE_ARTICLE_SELECT ?
                fieldTemplate.variable : content?.normativeArticleVariable
        })
        const col = [{
            field: fieldTemplate.label,
            headerName: fieldTemplate.label,
            width: 140,
            editable: true,
        }]
        let newColumns = [...column, ...col]
        setColumn(newColumns)
        let stokeForRow = {
            [fieldTemplate.label]: fieldTemplate.type,
        }
        const rowObj = row[0]
        let newRow = {...rowObj, ...stokeForRow}
        setRow([newRow])
        handleClose()
        setSelectedFieldTemplateIndex(null)
    }

    const handleDeleteLast = () => {
        let newContent = [...content.offenseWindow]
        newContent.pop()
        setFieldValue('content', {
            ...content,
            offenseWindow: newContent,
        })
        let deleteColomn = [...column]
        deleteColomn.pop()
        
        setColumn(deleteColomn)
       

    }

    const handleMutateOffense = (params) => {
        if (params.field !== 'id') {
            let newOffenseWindow = [...offenseWindow]
            newOffenseWindow.map((el, index) => {
                if (params.field === el.label) {
                    setSelectedFieldTemplateIndex(index)
                }
            })
            handleOpen()
        }
    }

    const handleFieldTemplateChange = fieldTemplate => {
        setFieldValue('content', {
            ...content,
            offenseWindow: offenseWindow.map((el, i) => {
                if (i === selectedFieldTemplateIndex) {
                    return fieldTemplate
                }
                return el
            }),
            filesVariable: fieldTemplate.type === DynamicFields.DRAG_AND_DROP_FILES_UPLOAD ?
                fieldTemplate.variable : content?.filesVariable,
            normativeArticleVariable: fieldTemplate.type === DynamicFields.NORMATIVE_ARTICLES_TABLE ||
            fieldTemplate.type === DynamicFields.NORMATIVE_ARTICLE_SELECT ?
                fieldTemplate.variable : content?.normativeArticleVariable
        })
        const fakeColumn = [...column]
        let newColumn = [...column]
        fakeColumn.map((el, index) => {
            if (index === fieldTemplate.sequenceNumber) {
                newColumn[index] = {
                    field: fieldTemplate.label,
                    headerName: fieldTemplate.label,
                    width: 140,
                    editable: true,
                }
            }
        })
        let newRow = {}
        const fakeRow = [...row]
        const fakeRowObj = fakeRow[0]
        let i = 0
        for (const key in fakeRowObj) {
            if (i === fieldTemplate.sequenceNumber) {
                let newPeremen = {
                    [fieldTemplate.label]: fieldTemplate.type
                }
                newRow = {...newRow, ...newPeremen}
            } else { newRow = {...newRow, ...{ [key]: fakeRowObj[key]}}}
            i++
        }
        setColumn(newColumn)
        setRow([newRow])
        handleClose()
        setSelectedFieldTemplateIndex(null)
    }


    return <>
        <div className={style.addButton}>
            <FakeAddCheckListField fakeFields={offenseWindow}
                       handleAddButtonClick={handleOpen}
                       handleDeleteLast={handleDeleteLast}
                       handleFieldTemplateDelete={handleFieldTemplateDelete}
                       handleSequenceNumberChange={handleSequenceNumberChange}
                       handleFieldTemplateClick={handleFieldTemplateClick}
            />
        </div>
        <Typography variant="h6"> Это таблица выбора столбцов</Typography>
         <div style={{ height: 180, width: '100%' }}>
            <DataGrid
                rows={row}
                columns={column}
                pageSize={[1]}
                editRowsModel
                disableSelectionOnClick={true}
                disableColumnFilter={true}
                disableColumnMenu={true}
                disableColumnSelector={true}
                disableDensitySelector={true}
                disableVirtualization={true}
                onCellClick={handleMutateOffense}
            />
        </div>

        <div style={{marginTop: '20px', display: 'flex', flexWrap: 'wrap', rowGap: '10px'}}>
            <Typography variant="h6">Дерево чек-листа</Typography>
            {normativeArticles.length !== 0 && <TreeCheckListFiller checkListId={content.checkListId} />}
        </div>
        <AddFieldTemplateDialog open={open}
                                handleClose={handleClose}
                                handleSave={handleAddFieldTemplate}
                                handleFieldTemplateChange={handleFieldTemplateChange}
                                selectedFieldTemplate={selectedFieldTemplateIndex !== null ?
                                    offenseWindow[selectedFieldTemplateIndex] : null}
        />
        <AddDocumentCheckList />
    </>
}